module.exports = __webpack_public_path__ + "img/facts-all_1958.5f5ebb28.png";